export default {"src":"/_next/static/media/sunset.f8e3f8d0.svg","height":300,"width":392,"blurWidth":0,"blurHeight":0};